<template>
  <div class="p-6 pb-0">
    <div class="flex border-b border-[#E0E0E0]">
      <div
        data-testid="my-calendar.task-tab-header.my-tasks-tab"
        :class="['switch-tab  hover:bg-[#F0F0F0]', { active: activeTaskTab === 'myTasks' }]"
        @click="$emit('tab-change', 'myTasks')"
      >
        <span>My Tasks</span>
      </div>
      <div
        data-testid="my-calendar.task-tab-header.patient-tasks-tab"
        :class="['switch-tab hover:bg-[#F0F0F0]', { active: activeTaskTab === 'patientTasks' }]"
        @click="$emit('tab-change', 'patientTasks')"
      >
        <span>Patient Tasks</span>
      </div>
    </div>
  </div>
</template>


<script setup>
defineProps(['activeTaskTab'])
</script>

<style scoped>
.switch-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  cursor: pointer;
  color: #666666;
  font-weight: 400;
  border-radius: 4px 4px 0 0;
}
.switch-tab.active {
  background-color: #F9FBFD;
  color: #004879;
  border: 1px solid #004879;
  border-radius: 4px 4px 0 0;
  font-weight: 600;
}

</style>